import { refreshTokenHandler, setLocaleHeader } from '@brightdrop/auth-client';
import {
  type BaseQueryFn,
  createApi,
  type FetchArgs,
  type FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

let baseUrl = '';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '', // placeholder, dynamically replaced
  prepareHeaders: async (headers) => {
    const response = await refreshTokenHandler();
    const { accessToken: token } = response ?? {};

    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    if (!headers.has('Accept')) {
      headers.set('Accept', 'application/json, text/plain, */*');
    }
    if (!headers.has('content-type')) {
      headers.set('Content-Type', 'application/json');
    }
    setLocaleHeader(headers);

    return headers;
  },
});

// Adapted from https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#constructing-a-dynamic-base-url-using-redux-state
const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${baseUrl}/entitlement${urlEnd}`;

  const adjustedArgs =
    typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };
  return rawBaseQuery(adjustedArgs, api, extraOptions);
};

export const configureEntitlementsClient = ({
  apiBaseUrl,
}: {
  apiBaseUrl: string;
}) => {
  baseUrl = apiBaseUrl;
};

export const initialApi = createApi({
  reducerPath: 'entitlementsRtkClient',
  refetchOnMountOrArgChange: 10,
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}), // injected in generated-api.ts
});
